/**
 * Extracts the product name segment from an ARI string.
 *
 * @see go/ari for the full ARI format.
 * Example:
 *   ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
 *   -> amplitude
 */
export const extractProductNameFromARI = (ari?: string | null): string | null => {
	if (!ari) {
		return null;
	}

	const ariParts = ari.split(':');

	if (ariParts.length < 3) {
		return null;
	}

	return ariParts[2];
};
